export default __webpack_public_path__ + "img/phoneIcon.90588010.svg";